module.exports = __webpack_public_path__ + "media/St 4-charging station-incorrect.ed6f6543.wav";